export default function (tns) {
  const careToolContainer = document.querySelector(
    '.CareCredit .CareCredit__care-tools.desktop .wp-block-group.items > .wp-block-group__inner-container'
  )

  if (!careToolContainer) {
    return
  }

  tns({
    container: careToolContainer,
    gutter: 0,
    nav: false,
    autoHeight: true,
    items: 3,
    edgePadding: 0,
    loop: false,
    preventScrollOnTouch: 'force',
  })
}
